import {extend} from 'umi-request';
import defaultSetting from "@/../config/defaultSetting";
import {API} from "../../typings";
import {history} from "umi";
import {getHeaders} from "@/util/auth";

/**
 * request对象
 */
const request = extend({
    prefix: defaultSetting?.gateway || '',
    timeout: 60000,
});

/**
 * 中间件
 * @param ctx context
 * @param next 执行函数
 */
const check = async (ctx: any, next: any) => {
    ctx.req.options.headers = getHeaders();
    await next();
    if (ctx.res.code == 401) {
        history.push("/index");//无权限页面;
    }

}
request.use(check);


/**
 * 发送post请求
 * @param url 请求地址
 * @param body 请求载荷
 * @param onSuccess code200回调
 * @param onFail code500回调
 * @param onFinally 最后执行
 * @param onError 错误捕获
 * @param options 其他选项
 */
// @ts-ignore
export async function post(url: string = "", body: any = {}, onSuccess: (res:any) => void = undefined, onFail: (res:any) => void = undefined, onFinally: () => void = undefined, onError: (error:any) => void = undefined, options?: {
    [key: string]: any
}) {
    let res = {};
    const isFormData = body instanceof FormData;
    await request<API.Response>(url, {
        method: 'POST',
        headers: isFormData ? {} : {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    }).then((r:any) => {
        res = r;
        if (r?.code == 200 || r?.code == 260) {
            onSuccess?.(r);
        } else {
            onFail?.(r);
        }
    }).catch((error:any) => {
        onError?.(error);
    }).finally(() => {
        onFinally?.();
    });
    return res as API.Response;
}

/**
 * 发送get请求
 * @param url 请求地址
 * @param params 请求参数
 * @param onSuccess code200回调
 * @param onFail code500回调
 * @param onFinally 最后执行
 * @param onError 错误捕获
 * @param options 其他选项
 */
// @ts-ignore
export async function get(url: string = "", params: {}, onSuccess:(res:any) => void = undefined, onFail: (res:any) => void = undefined, onFinally: () => void = undefined, onError: (error:any) => void = undefined, options?: {
    [key: string]: any
}) {
    let res = {};
    await request<API.Response>(url, {
        method: 'GET',
        params: {
            ...params,
        },
        ...(options || {}),
    }).then((r:any) => {
        res = r;
        if (r?.code == 200 || r?.code == 260) {
            onSuccess?.(r);
        } else {
            onFail?.(r);
        }
    }).catch((error:any) => {
        onError?.(error);
    }).finally(() => {
        onFinally?.();
    });
    return res as API.Response;
}
// @ts-ignore
export async function del(url: string = "", params: {}, onSuccess:(res:any) => void = undefined, onFail: (res:any) => void = undefined, onFinally: () => void = undefined, onError: (error:any) => void = undefined, options?: {
    [key: string]: any
}) {
    let res = {};
    await request<API.Response>(url, {
        method: 'DELETE',
        params: {
            ...params,
        },
        ...(options || {}),
    }).then((r:any) => {
        res = r;
        if (r?.code == 200 || r?.code == 260) {
            onSuccess?.(r);
        } else {
            onFail?.(r);
        }
    }).catch((error:any) => {
        onError?.(error);
    }).finally(() => {
        onFinally?.();
    });
    return res as API.Response;
}
// @ts-ignore
export async function put(url: string = "", params: {}, onSuccess:(res:any) => void = undefined, onFail: (res:any) => void = undefined, onFinally: () => void = undefined, onError: (error:any) => void = undefined, options?: {
    [key: string]: any
}) {
    let res = {};
    await request<API.Response>(url, {
        method: 'PUT',
        params: {
            ...params,
        },
        ...(options || {}),
    }).then((r:any) => {
        res = r;
        if (r?.code == 200 || r?.code == 260) {
            onSuccess?.(r);
        } else {
            onFail?.(r);
        }
    }).catch((error:any) => {
        onError?.(error);
    }).finally(() => {
        onFinally?.();
    });
    return res as API.Response;
}

export default request;
